export default __webpack_public_path__ + "static/insight-39a0fd1aa640f9bab3b6a04b8b820104.png";